import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  // UI Screen Checks.
  isSmallScreen: boolean = false;
  isMobileScreen: boolean = false;
  shouldShowFullWidth: boolean = true;

  readonly MOBILE_BREAKPOINT = 550;
  readonly SMALL_SCREEN_BREAKPOINT = 1200;

  checkScreenSize(): void {
    this.isMobileScreen = window.innerWidth <= this.MOBILE_BREAKPOINT;
    this.isSmallScreen = window.innerWidth <= this.SMALL_SCREEN_BREAKPOINT;
    this.shouldShowFullWidth = !this.isSmallScreen;
  }

  setShowFullWidth(showFullWidth: boolean) {
    this.shouldShowFullWidth = showFullWidth;
  }
}
